// Stable id shared by the drawer's touch points: the declarative mount in
// routes/root.tsx, the hamburger's `useModal(SIDEBAR_MODAL_ID)` in the header,
// and the redeem modal's transaction-history link. Passing the component to
// `useModal` instead would mint a random uid that would not match the
// declarative instance, giving two separate drawers.
//
// It lives in its own module rather than in ./index.tsx on purpose: every
// importer would otherwise pull the whole drawer into its chunk, and root.tsx is
// the entry chunk.
export const SIDEBAR_MODAL_ID = 'sidebar-drawer'
